import React, { useCallback } from 'react';

const TablaInventarioPlana = ({ datosInventario }) => {

    const manejarCambioExistencia = useCallback((event, datosFila) => {
        const valorBruto = event.target.value;
        const nuevaExistenciaActual = parseInt(valorBruto, 10);

        // Acepta números enteros, incluyendo negativos.
        if (valorBruto === '') {
            datosFila.handleActualizar(0);
        } else {
            datosFila.handleActualizar(isNaN(nuevaExistenciaActual) ? 0 : nuevaExistenciaActual);
        }
    }, []);

    // Determina la clase CSS para la agrupación de productos (Alterna por Producto)
    const obtenerClasePorProducto = (idProducto, indice) => {
        let indiceProductoUnico = 0;
        for (let i = 0; i <= indice; i++) {
            if (i === 0 || datosInventario[i].productoId !== datosInventario[i - 1].productoId) {
                indiceProductoUnico++;
            }
        }
        // Usamos 'table-active' (gris muy sutil) para la alternancia de filas
        return indiceProductoUnico % 2 === 0 ? '' : 'table-active';
    };

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover table-sm nowrap" style={{ width: "100%" }}>
                <thead>
                    <tr className="table-light">
                        <th style={{ width: '15%' }} className="text-dark">Producto</th>
                        <th style={{ width: '10%' }} className="text-dark">Lote</th>
                        <th className="text-dark">Ubicacion</th>
                        <th className="text-dark">Precio</th>
                        <th className="text-dark">Costo</th>
                        <th className="text-dark">Existencia sistema</th>
                        <th className="text-dark">Sistema Actual</th>
                        <th className="text-dark">Balance</th>
                        <th className="text-dark">Costo Total</th>
                        <th style={{ width: '5%' }} className="text-dark">Acción</th>
                    </tr>
                </thead>
                <tbody>
                    {datosInventario.length === 0 ? (
                        <tr>
                            <td colSpan="10" className="text-center">No hay información</td>
                        </tr>
                    ) : (
                        datosInventario.map((fila, indice) => {
                            const claseBalance = fila.balance >= 0 ? "text-success" : "text-danger";
                            const claseFila = obtenerClasePorProducto(fila.productoId, indice);

                            const esPrimeraFilaProducto = indice === 0 || fila.productoId !== datosInventario[indice - 1].productoId;
                            const esPrimeraFilaLote = indice === 0 || fila.loteId !== datosInventario[indice - 1].loteId;

                            const spanProducto = datosInventario.slice(indice).findIndex(d => d.productoId !== fila.productoId) === -1
                                ? datosInventario.length - indice
                                : datosInventario.slice(indice).findIndex(d => d.productoId !== fila.productoId);

                            const spanLote = datosInventario.slice(indice).findIndex(d => d.loteId !== fila.loteId || d.productoId !== fila.productoId) === -1
                                ? datosInventario.length - indice
                                : datosInventario.slice(indice).findIndex(d => d.loteId !== fila.loteId || d.productoId !== fila.productoId);

                            return (
                                <tr key={`${fila.loteInventarioId}`} className={claseFila}>

                                    {esPrimeraFilaProducto && (
                                        <td
                                            rowSpan={spanProducto}
                                            className="font-weight-bold"
                                            style={{
                                                verticalAlign: 'middle',
                                                fontWeight: '600',
                                                borderRight: '2px solid #ccc',
                                            }}
                                        >
                                            <div>{fila.productoNombre}</div>
                                            <div className="text-muted small" style={{ fontWeight: '400', marginTop: '4px' }}>
                                                ({fila.productoCodigo})
                                            </div>
                                        </td>
                                    )}

                                    {esPrimeraFilaLote && (
                                        <td
                                            rowSpan={spanLote}
                                            style={{
                                                verticalAlign: 'middle',
                                                fontWeight: '500',
                                                borderRight: '1px solid #ddd',
                                            }}
                                        >
                                            {fila.loteNombre}
                                        </td>
                                    )}

                                    <td className="text-muted small">{fila.tipoLote}</td>
                                    <td>L{fila.precio.toFixed(2)}</td>
                                    <td>L{fila.costo.toFixed(2)}</td>
                                    <td>{fila.existenciaSistema}</td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control form-control-sm existencia-actual-input"
                                            value={fila.existenciaActual}
                                            onChange={(e) => manejarCambioExistencia(e, fila)}
                                        />
                                    </td>
                                    <td>
                                        <span className={claseBalance}>
                                            {fila.balance >= 0 ? '+' : ''}{fila.balance}
                                        </span>
                                    </td>
                                    <td>L{fila.costoTotal < 0 ? '-' : ''}{Math.abs(fila.costoTotal).toFixed(2)}</td>

                                    {esPrimeraFilaProducto && (
                                        <td rowSpan={spanProducto} style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={fila.handleEliminar}
                                                title="Eliminar producto de la lista de inventario"
                                            >
                                                <i className="fas fa-trash-alt"></i>
                                            </button>
                                        </td>
                                    )}
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default TablaInventarioPlana;